import {
  getCoreRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table"
import { useMemo } from "react"

import { Table } from "~/components/table/Table"
import { ExportRequestResponseDto } from "~/gen/api"
import { useColumns } from "~/pages/Brand/DataTransfer/Export/columns"
import { PAGE_SIZE } from "~/pages/Brand/Suppliers/List/SupplierMonitoringWrapper"

type Props = {
  data: ExportRequestResponseDto[]
  total: number
}

export const ExportRequestsTable: React.FC<Props> = ({
  data = [],
  total,
}: Props) => {
  const columns = useColumns()

  const pageCount = useMemo(
    () => (total ? Math.ceil(total / PAGE_SIZE) : 0),
    [total]
  )

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageSize: PAGE_SIZE,
      },
    },
    pageCount,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  })

  return <Table table={table} />
}
